'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var SHOW_ALERT = exports.SHOW_ALERT = '@SweetAlert/Show';
var HIDE_ALERT = exports.HIDE_ALERT = '@SweetAlert/Hide';